import Accenture from "../asset/img/accenture.png";
import Deriv from "../asset/img/deriv.jpg";
import Doctor2u from "../asset/img/bpHealthcare.jpg";
import MM from "../asset/img/mmLogo.png";

export const WORK_EXPERIENCE = [
  {
    id: 1,
    img: Accenture,
    company: "Accenture Technology",
    title: "Packaged App Development Analyst",
    period: "Aug 2024 – Current",
    isCurrent: true,
    details: {
      description: [
        "Developed proof-of-concept banking features and internal tooling demos, automating frontend workflows to improve developer productivity with React.js.",
        "Upskilled in React Native, mobile security, AI-assisted development practices, AWS cloud services, and Node.js.",
      ],
      project: "MBB S2U V5",
      projectDesc: [
        "Integrated enhanced security features for a major digital banking app in Malaysia using React Native, Xcode, and Android Studio across 50+ services serving millions of active users.",
        "Delivered the Secure2u (S2U) V5 upgrade with updated backend services and authentication flows across multiple transaction modules.",
        "Configured 2FA, RSA authentication, and push notifications for the upgraded S2U across transfer flows, ensuring compliance with banking security standards.",
      ],
      techStack: "React Native, Xcode, Android Studio",
    },
  },
  {
    id: 2,
    img: MM,
    company: "MoneyMatch",
    title: "Front-end Software Engineer",
    period: "Feb 2023 – Apr 2024",
    details: {
      description: [
        "Built landing pages for moneymatch.co with Next.js and Strapi CMS, focusing on SEO, responsive design and content scalability.",
        "Developed and integrated Orbit Flow with React.js, implementing remittance-related features to support user interaction and platform functionality.",
        "Collaborated with cross-functional teams in an Agile environment, focusing on sprint planning, stand-ups, and retrospectives.",
        "Consistently maintained a completion rate of 70% to 100% for assigned tickets within two-week sprints, ensuring high productivity and timely project delivery.",
      ],
      techStack:
        "ReactJs, NextJs, Material Ui, Strapi CMS, GitHub, Restful API",
    },
  },
  {
    id: 3,
    img: Deriv,
    company: "Deriv",
    title: "Software Engineering Trainee",
    period: "July 2022 – Dec 2022 ",
    details: {
      description: [
        "Built responsive web applications using React, focusing on modular component architecture and reusable UI components.",
        "Developed a cross-platform food recipe mobile app using Flutter and Dart, managing the project from design to functional prototype.",
        "Applied cybersecurity auditing tools and best practices during the development lifecycle to identify and mitigate vulnerabilities.",
        "Won 2nd Place in a cryptocurrency-focused hackathon, designing a blockchain-integrated solution within a 2-week sprint.",
        "Completed a full-stack rotation covering frontend, backend, business intelligence, cybersecurity, product design, DevOps, trading, and quality assurance.",
      ],
      techStack:
        "JavaScript, React, Flutter, GitHub, Vercel, SQL, Docker, Robot Framework, Figma, AWS, PostgreSQL, Metabase, Python, APIs, Kali Linux,  VMware, Metasploitable2, Redis, Airflow",
    },
  },
  {
    id: 4,
    img: Doctor2u,
    company: "BP Healthcare/ Doctor2u",
    title: "Junior Software Engineer",
    period: "Sept 2021 – Jun 2022",
    details: {
      description: [
        "Worked on the development of high-traffic KLIA COVID-19 vaccine portal interfaces using Angular, Material UI, and TypeScript, improving accessibility for both admin and customer modules.",
        "Provided on-site technical support for airport staff and customers, ensuring smooth system adoption and process flow during the rollout.",
        "Engineered backend administrative dashboards and automated report generation systems using C#, reducing manual data processing time for internal stakeholders.",
        "Collaborated directly with product owners to translate complex user requirements into technical specifications, ensuring 100% alignment with project objectives in a fast-paced environment.",
      ],
      techStack: "Angular Material, TypeScript, C#, Git",
    },
  },
];
